import { RootReducer } from 'store/reducers';
import { createSelector } from 'reselect';
import { SsiWarningSafety, SsiWarningStyle } from 'types/check';

export const isBrandedDocument = (state: RootReducer) =>
  state.assessment.isBrandedDocument;

export const getJobToken = (state: RootReducer) => state.assessment.jobToken;

export const assessmentWarnings = (state: RootReducer) =>
  state.assessment.ssiDetails?.warnings;

export const isDocumentStyleAvailable = createSelector(
  assessmentWarnings,
  (assessmentWarnings): boolean =>
    !~Object.values(SsiWarningStyle).indexOf(
      assessmentWarnings?.warningStyle as SsiWarningStyle
    )
);

export const isDocumentSafetyAvailable = createSelector(
  assessmentWarnings,
  (assessmentWarnings): boolean =>
    assessmentWarnings?.warningSafety !==
    SsiWarningSafety.SSI_CHECK_FOR_UNBRANDED_IS_UNSUPPORTED
);
